module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel4-en-GB@3x-577a66b1c479ea2a4cc8dfac18880bc4.png";